import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApiResponseDocument,
  OpalApiRequestParams,
} from '../../schema'

export function readAllBoardObjectCollections(
  params: OpalApiRequestParams<'GetBoardObjectCollectionsV3'>
): Promise<OpalApiResponseDocument<'GetBoardObjectCollectionsV3', 200>> {
  const url = new URL(`/board_object_collections/v3`, window.location.origin)

  url.search = queryString(params.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
